<template>
  <div class="trends-container">
    <div class="archive-head">
      <img src="../../assets/images/logo.png" alt="" />
    </div>
    <div class="search-content">
      <h1>Fund Topic Trends</h1>
      <div class="input-item">
        <el-input
          placeholder="Enter the keywords here and start exploring"
          v-model="keyword"
          class="input-with-select"
          @keyup.enter.native="handleSearch"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleSearch"
          ></el-button>
        </el-input>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyword: "",
    };
  },
  methods: {
    handleSearch() {
      this.$router.push({
        name: "trends-explore",
        query: {
          keyword: this.keyword,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.trends-container {
  .archive-head {
    width: 100%;
    background-color: #0275d8;
    color: white;
    font-size: 16px;
    height: 54px;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    img {
      width: 100px;
    }
  }
  .search-content {
    margin: 108px auto;
    width: 900px;
    h1 {
      font-size: 54px;
      font-weight: 900;
      text-align: center;
      margin-bottom: 36px;
      color: #0962bc;
    }
  }
}
</style>
<style lang="less">
.trends-container {
  .input-with-select {
    // height: 64px;
    font-size: 16px;
  }
  .el-input__inner {
    height: 64px;
    line-height: 64px;
  }
  .el-input-group__prepend {
    width: 140px;
    line-height: 64px;
    box-sizing: border-box;
  }
  .el-input-group__append {
    .el-button {
      font-size: 22px;
      font-weight: 900;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Trends/index.vue